<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="活动类型">
              <j-dict-select-tag
                v-model="queryParam.activityType"
                placeholder="请选择活动类型"
                dictCode="activity_type"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="活动状态">
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="请选择活动状态"
                dictCode="obj_status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!--  活动维护信息录入  -->
    <template>
      <j-modal
        title="活动暂停信息录入"
        width="700px"
        :visible="stopFlag"
        :confirmLoading="confirmLoading"
        switchFullscreen
        @ok="handleStopOk"
        @cancel="handleStopCancel"
        cancelText="关闭"
      >
        <a-spin :spinning="confirmLoading">
          <a-form>
            <a-form-item
              label="活动暂停标识类型"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-model="stopType"
                placeholder="请选择暂停标识类型"
                @change="fieldValue"
              >
                <a-select-option
                  v-for="(item, index) in activityStopFlagType"
                  :value="item.value"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item
              label="活动暂停维护图"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-show="stopImgShow"
            >
              <UploadImage
                :imgUrl="stopImg"
                @handleFileList="handleImageList"
              />
              <!-- <a-upload
                name="file"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="upload"
                :before-upload="beforeUpload"
                @change="handleChangeUpload"
              >
                <img
                  v-if="maintainImg"
                  :src="maintainImg"
                  alt="avatar"
                  style="height: 104px; max-width: 300px"
                />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload> -->
              <!--<j-image-upload :isMultiple="false" v-model="maintainImg"></j-image-upload>-->
            </a-form-item>
            <a-form-item
              label="活动暂停描述"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-if="stopTextShow"
            >
              <a-textarea
                type="text"
                :max-length="500"
                rows="4"
                v-model="activityDescribe"
                placeholder="请输入活动描述,限制500字"
              />
            </a-form-item>
            <a-form-item
              label="活动暂停引导跳转地址"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-if="stopJumpShow"
            >
              <a-input v-model="jumpUrl" placeholder="请输入引导用户跳转地址" />
            </a-form-item>
          </a-form>
        </a-spin>
      </j-modal>
    </template>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新建活动</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
          <!--<a-menu-item key="2" @click="changeStatus('1')">批量启用</a-menu-item>-->
          <!--<a-menu-item key="3" @click="changeStatus('0')">批量停用</a-menu-item>-->
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.status)"
            checked-children="启用"
            un-checked-children="未启用"
            @click="handleChange(record)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a
            @click="handleEdit(record)"
            :disabled="record.status == '1' ? true : false"
            >编辑活动</a
          >
          <a-divider type="vertical" />
          <a
            @click="handleDelete(record.id)"
            :disabled="record.status == '1' ? true : false"
            >删除</a
          >
        </span>
      </a-table>
    </div>

    <activity-manage-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></activity-manage-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import ActivityManageModal from './modules/ActivityManageModal';
import { postAction, getAction, postTag } from '../../../api/manage';
import JImageUpload from '@/components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener('load', () => callback(reader.result));
//   reader.readAsDataURL(img);
// }

export default {
  name: 'ActivityManage',
  mixins: [JeecgListMixin],
  components: {
    ActivityManageModal,
    JImageUpload,
    UploadImage,
  },
  data() {
    return {
      description: '活动管理页面',
      activityStopFlagType: [
        {
          name: '请选择',
          value: '0',
        },
        {
          name: '弹框',
          value: '1',
        },
        {
          name: '图片',
          value: '2',
        },
      ],
      loading: false,
      upload:
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_FILE_UPLOAD +
        '/upload',
      stopImgShow: false,
      stopTextShow: false,
      stopJumpShow: false,
      stopType: '0',
      stopFlag: false,
      confirmLoading: false,
      maintainImg: '',
      stopImg: '',
      activityDescribe: '',
      jumpUrl: '',
      modelId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      // 表头
      columns: [
        {
          title: '活动名称',
          align: 'center',
          dataIndex: 'name',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 12
              ? text.substr(0, 12) + '...'
              : text;
          },
        },
        {
          title: '活动标题',
          align: 'center',
          dataIndex: 'title',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 12
              ? text.substr(0, 12) + '...'
              : text;
          },
        },
        {
          title: '活动类型',
          align: 'center',
          dataIndex: 'activityType_dictText',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '活动状态',
          align: 'center',
          dataIndex: 'status_dictText',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/activity/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/activity/delete',
        edit: process.env.VUE_APP_CMS_MARKETING + '/activity/edit',
        queryById: process.env.VUE_APP_CMS_MARKETING + '/activity/queryById',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/activity/deleteBatch',
        updateStatus:
          process.env.VUE_APP_CMS_MARKETING + '/activity/updateStatus',
      },
      dictOptions: {},
    };
  },
  computed: {},
  methods: {
    initDictConfig() {},
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    //批量启用、停用
    changeStatus(num) {
      var title_tmp = '';
      var content_tmp = '';
      if (num === '1') {
        title_tmp = '确认启用';
        content_tmp = '是否启用选中数据';
      } else {
        title_tmp = '确认停用';
        content_tmp = '是否停用选中数据';
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
          ids += this.selectedRowKeys[i] + ',';
        }
        var that = this;
        this.$confirm({
          title: title_tmp,
          content: content_tmp,
          onOk: function () {
            that.loading = true;
            postAction(that.url.updateStatus, { ids: ids, type: num })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  //刷新页面
                  that.loadData();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },

    //启用、停用
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要停用所选数据?';
      var that = this;
      var type = record.status === '1' ? '0' : '1';
      this.$confirm({
        title: record.status === '1' ? '停用' : '启用',
        content: record.status === '1' ? strClose : strOpen,
        onOk() {
          that.modelId = record.id;
          that.stopImg = '';
          if (type === '0') {
            //暂停活动
            getAction(that.url.queryById, { id: record.id }).then((res) => {
              if (res.success) {
                console.log(res);
                that.stopFlag = true;
                that.maintainImg = res.result.maintainImg;
                if (res.result.maintainImg) {
                  that.stopImg =
                    process.env.VUE_APP_FILE_PATH + res.result.maintainImg;
                }
                that.activityDescribe = res.result.activityDescribe;
                that.jumpUrl = res.result.jumpUrl;
                if (res.result.stopType === 1) {
                  that.stopType = '1';
                  that.stopJumpShow = true;
                  that.stopTextShow = true;
                } else if (res.result.stopType === 2) {
                  that.stopType = '2';
                  that.stopJumpShow = true;
                  that.stopImgShow = true;
                  // setTimeout(() => {
                  //   that.stopImg =
                  //     process.env.VUE_APP_FILE_PATH + res.result.maintainImg;
                  // });
                } else {
                  that.stopType = '0';
                  that.stopImgShow = false;
                  that.stopTextShow = false;
                }
              } else {
                this.$message.warning(res.message);
              }
            });
          } else if (type === '1') {
            //启用
            that.stopFlag = false;
            postAction(that.url.updateStatus, {
              ids: record.id,
              type: type,
            }).then((res) => {
              if (res.success) {
                //刷新页面
                that.loadData();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            });
          }
        },
      });
    },

    isChecked(statusTemp) {
      if (statusTemp === '1') {
        return true;
      } else return false;
    },

    loadDataTmp() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      this.loading = true;
      getAction(this.url.list).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },

    handleStopCancel() {
      this.$emit('close');
      this.stopFlag = false;
      this.stopImgShow = false;
      this.stopTextShow = false;
      this.stopJumpShow = false;
    },

    handleStopOk() {
      const that = this;
      that.confirmLoading = true;
      let httpurl = that.url.edit;
      let submitData = {
        id: that.modelId,
        status: '0',
        stopType: that.stopType,
        maintainImg: that.maintainImg,
        activityDescribe: that.activityDescribe,
        jumpUrl: that.jumpUrl,
      };
      postTag(httpurl, submitData)
        .then((res) => {
          if (res.success) {
            // that.loadDataTmp();
            that.loadData();
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warning(res.message);
          }
        })
        .finally(() => {
          that.confirmLoading = false;
          that.$emit('close');
          that.stopFlag = false;
          that.stopImgShow = false;
          that.stopTextShow = false;
          this.stopJumpShow = false;
        });
    },

    fieldValue(e) {
      if (e === '1') {
        this.stopTextShow = true;
        this.stopImgShow = false;
        this.stopJumpShow = true;
      } else if (e === '2') {
        this.stopImgShow = true;
        this.stopTextShow = false;
        this.stopJumpShow = true;
      } else {
        this.stopImgShow = false;
        this.stopTextShow = false;
        this.stopJumpShow = false;
      }
    },

    // handleChangeUpload(info) {
    //   if (info.file.status === 'uploading') {
    //     this.loading = true;
    //     return;
    //   }
    //   if (info.file.status === 'done') {
    //     // Get this url from response in real world.
    //     /*getBase64(info.file.originFileObj, imageUrl => {
    //         this.maintainImg = imageUrl;
    //         this.loading = false;
    //       });*/

    //     info.file.url = info.file.response.result.url;
    //     this.maintainImg = info.file.response.result.url;
    //     return info.file;
    //   }
    // },
    handleImageList(fileList) {
      console.log(fileList, this.maintainImg);
      this.stopImg = process.env.VUE_APP_FILE_PATH + fileList.fileName;
      this.maintainImg = fileList.fileName;
    },
    // beforeUpload: function (file) {
    //   var fileType = file.type;
    //   if (fileType.indexOf('image') < 0) {
    //     this.$message.warning('请上传图片');
    //     return false;
    //   }
    // },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
